
import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

const UnderlinedTabs = TabsPrimitive.Root

const UnderlinedTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "w-full justify-start border-b rounded-none bg-transparent p-0",
      className
    )}
    {...props}
  />
))
UnderlinedTabsList.displayName = "UnderlinedTabsList"

const UnderlinedTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-brand-blue data-[state=active]:shadow-none rounded-none px-4 py-2",
      className
    )}
    {...props}
  />
))
UnderlinedTabsTrigger.displayName = "UnderlinedTabsTrigger"

const UnderlinedTabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-6 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
))
UnderlinedTabsContent.displayName = "UnderlinedTabsContent"

export { UnderlinedTabs, UnderlinedTabsList, UnderlinedTabsTrigger, UnderlinedTabsContent }
